import {Suspense, useEffect, useMemo} from "react";
import {useSelector} from "react-redux";


import {Route, Routes, useNavigate} from 'react-router-dom';
import Loading from "../components/Loading";
import PrivateRoute from "./PrivateRoute";
import PublicRouter from "./PublicRouter";
import {formatAppSnsType, rememberMeLogin, removeAllStorage} from "../../utils/helpers";
import {useDispatch} from "react-redux";
import {getCurrentUser, logOutRequest, resetState} from "../../pages/Account/redux/actions";
import API, {ROUTES} from "../api/api";
import useCallSocket from "../customHooks/useCallSocket";
import useNativeRegisterAward from "../customHooks/useNativeRegisterAward";


let routePublics = [];
let routePrivates = [];
let routeExtras = [];
const context = require.context("./../../pages/", true, /route.js$/);

context.keys().forEach((path) => {
    let routes = require('../../pages/' + path.replace('./', '')).default;
    if (routes.length > 0) {
        routes.forEach((route, id) => {
            if (route.hasOwnProperty('public') &&  route.public) {
                routePublics.push(route);
            } else if (route.hasOwnProperty('public') &&  !route.public) {
                routePrivates.push(route);
            } else if(!route.hasOwnProperty('public')){
                routeExtras.push(route);
            }
        })
    }
});

const AppRouter = () => {
    const {userInfo, token, type} = useSelector((state) => state.authReducers);
    const dispatch = useDispatch();

    // socket log out user
    useCallSocket(token,userInfo);
    useNativeRegisterAward();

    const getApiCurrentUser = () => {
        API.get(ROUTES.API_GET_AUTH_ME).then((res) => {
            let response = res.data;
            // console.log(response, 'response');
            // window.sendDeviceKey(response.devices[0]?.device_key || '');
            dispatch(getCurrentUser(response));
        }).catch(e => {
            dispatch(resetState());
        });
    }

    useEffect(() => {
        // let deviceKeyLocalStorage = localStorage.getItem('DEVICE_KEY');
        // if (!deviceKeyLocalStorage) {
        //     console.log('!deviceKeyLocalStorage', deviceKeyLocalStorage);
        //     window.setDeviceKey(generateUuid())
        // }
        if (!token) {
            // console.log('!token', deviceKeyLocalStorage);
            localStorage.removeItem('DEVICE_KEY');
            // window.setDeviceKey(generateUuid());
        }
    }, [token])

    useEffect(() => {
        let deviceKeyLocalStorage = localStorage.getItem('DEVICE_KEY');
        console.log(deviceKeyLocalStorage, 'deviceKeyLocalStorage');
        if(window.sendDeviceKey){
            window.sendDeviceKey(deviceKeyLocalStorage);
        }
    }, [])

    useEffect(() => {

        const _APP_TOKEN = localStorage.getItem('_APP_TOKEN');
        if (_APP_TOKEN) {
            let rememberMe = localStorage.getItem('remember_me');
            switch (rememberMe) {
                case "0":
                    let tokenSessionStore = sessionStorage.getItem('_APP_TOKEN');
                    if (tokenSessionStore == _APP_TOKEN) {
                        rememberMeLogin(false, tokenSessionStore);
                        getApiCurrentUser();
                    } else {
                        let device = 'N/A';
                        if(userInfo && userInfo.devices && userInfo.devices[0] && userInfo.devices[0].login_type){
                            device = userInfo.devices[0].login_type;
                        }
                        window.logoutSNS(device);
                        let snsType = formatAppSnsType(localStorage.getItem('sns_type') || '');
                        window.nativeLogoutToken(snsType);
                        dispatch(resetState());
                    }
                    break;
                case "1":
                    getApiCurrentUser();
                    break;
                default:
                    dispatch(resetState());
                    break;
            }
        }

        // window.webviewLoaded();
    }, []);

    const renderRoutesPrivates =
        routePrivates && routePrivates.map(({component: Component, path, ...rest}, index) =>
            <Route key={index} path={path} {...rest} element={Component}
            />);
    const renderRoutesPublics =
        routePublics && routePublics.map(({component: Component, path, ...rest}, index) =>
            <Route key={index} path={path} {...rest} element={Component}
            />);
    const renderRoutesExtras =
        routeExtras && routeExtras.map(({component: Component, path, ...rest}, index) =>
            <Route key={index} path={path} {...rest} element={Component}
            />);
    return (
        <Suspense fallback={<Loading/>}>
            <Routes>
                <Route path="" element={<PublicRouter isAuth={userInfo.id}/>}>
                    {renderRoutesPublics}
                </Route>
                <Route path="" element={<PrivateRoute isAuth={userInfo.id}/>}>
                    {renderRoutesPrivates}
                </Route>
                <Route path="">
                    {renderRoutesExtras}
                </Route>
            </Routes>
        </Suspense>
    )
}

export default AppRouter;
